export default __webpack_public_path__ + "assets/images/WithMaskExtrema-96b3879b9368f144351fc1aee46f0621.png";